import { Check, Loader2 } from "lucide-react";

const STEPS = [
  "Préparation de votre dossier",
  "Lecture de votre description par notre bureau d'étude",
  "Prestations identifiées, contrôle des points de vigilance",
  "Chiffrage sur nos chantiers de référence",
  "Estimation prête",
];

// La progression vient du serveur (champ `progress` de l'étude) : aucune animation factice.
export default function AnalysisProgress({ active, progress }) {
  if (!active) return null;
  const pct = Math.max(0, Math.min(100, progress?.pct ?? 0));
  const step = progress?.step ?? 0;
  return (
    <div className="fixed inset-0 z-[80] bg-anthracite/85 backdrop-blur-md flex items-center justify-center p-4" role="status" aria-live="polite" data-testid="analysis-progress">
      <div className="w-full max-w-lg bg-ivory rounded-rama-lg p-8 md:p-10 shadow-2xl">
        <div className="font-mono-caption text-bordeaux-700 mb-2">Analyse en cours</div>
        <h2 className="font-display text-2xl md:text-3xl text-anthracite">Nous étudions votre projet</h2>
        <div className="mt-6 h-1.5 bg-black/5 rounded-full overflow-hidden">
          <div className="h-full bg-bordeaux-700 transition-[width] duration-700 ease-out" style={{ width: `${pct}%` }} data-testid="analysis-progress-bar" />
        </div>
        <div className="mt-1 flex items-center justify-between text-xs text-ink-soft">
          <span className="inline-flex items-center gap-1.5" data-testid="analysis-current-label">
            <Loader2 size={12} className="animate-spin" /> {progress?.label || STEPS[step]}
          </span>
          <span className="tabular-nums" data-testid="analysis-pct">{Math.round(pct)} %</span>
        </div>
        <ol className="mt-6 space-y-3">
          {STEPS.slice(0, 4).map((s, i) => (
            <li key={s} className={`flex items-start gap-3 ${i > step ? "opacity-40" : "opacity-100"}`} data-testid={`analysis-step-${i}`}>
              <span className={`mt-0.5 w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 border ${i < step ? "bg-bordeaux-700 border-bordeaux-700 text-ivory" : i === step ? "border-bordeaux-700 text-bordeaux-700" : "border-black/15 text-ink-soft"}`}>
                {i < step ? <Check size={13} /> : i === step ? <span className="w-2 h-2 rounded-full bg-bordeaux-700 animate-pulse" /> : <span className="text-xs">{i + 1}</span>}
              </span>
              <div className={`text-sm ${i <= step ? "text-anthracite" : "text-ink-soft"}`}>{s}</div>
            </li>
          ))}
        </ol>
        <p className="mt-6 text-xs text-ink-soft">
          Chaque étape s'affiche dès qu'elle est réellement terminée côté serveur. Ne fermez pas cette page.
        </p>
      </div>
    </div>
  );
}
